module.exports = __webpack_public_path__ + "img/实验实训计划.283cb236.svg";